import React from 'react';
import { Breadcrumb } from 'src/app/slice';
import { getBreadcrumbLabel } from './breadcrumbsHelper';
import { StyledLink, StyledTextButton } from './style';
import { LaunchFlag } from 'src/commons/components/LaunchFlag/LaunchFlag';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';

export const LinkBreadcrumb: React.FC<{ breadcrumb: Breadcrumb }> = ({
  breadcrumb,
}) => {
  if (breadcrumb.onClickCallback) {
    return (
      <StyledTextButton onClick={breadcrumb.onClickCallback}>
        {getBreadcrumbLabel(breadcrumb)}
        {!!breadcrumb.objectSuffix && (
          <LaunchFlag flag={{ type: 'beta', label: breadcrumb.objectSuffix }} />
        )}
      </StyledTextButton>
    );
  }

  return (
    <StyledLink
      href={breadcrumb.url}
      {...getTaktAttributes(
        `link-breadcrumb`,
        chromeComponents.HEADER,
        breadcrumb.url ? { url: breadcrumb.url, label: breadcrumb.label } : {},
      )}
    >
      {getBreadcrumbLabel(breadcrumb)}
      {!!breadcrumb.objectSuffix && (
        <LaunchFlag flag={{ type: 'beta', label: breadcrumb.objectSuffix }} />
      )}
    </StyledLink>
  );
};
